import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import debounce from 'lodash/debounce';

import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import Paper from '@mui/material/Paper';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Avatar from '@mui/material/Avatar';
import TextField from '@mui/material/TextField';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import red from '@mui/material/colors/red';

import TabPanel from '../../components/TabPanel';
import { ColoredButton } from '../../components/Buttons/colored';
import * as ROUTES from '../../constants/routes';
import ImageUpload from '../../components/Dialogs/imageUpload';
import { uploadFile, autoSuggestCities } from '../../store/actions/common';
import { userOnBoardBasic } from '../../store/actions/register';
import { _lt } from '../../localization/locale';
import {
  fetchCountries,
  fetchLangs,
  fetchSports,
} from '../../store/actions/common';
import formImage from '../../assets/images/Guardian_01.jpg';
import { useTheme } from '@mui/material/styles';

function a11yProps(index) {
  return {
    id: `tab-${index}`,
    'aria-controls': `tabpanel-${index}`,
  };
}

const GuardianOnBoardBasic = (props) => {
  const theme = useTheme();

  const classes = {
    root: {
      background:
        'linear-gradient(#d3cff620,#ffffff,#ffffff,#d3cff610,#d3cff620)',
      backgroundSize: 'cover',
      height: 'calc(100vh - 2rem)',
      overflow: 'scroll',
      [theme.breakpoints.down('xs')]: {
        background: 'white',
      },
    },
    formWrapper: {
      width: '100%',
      maxWidth: '1200px',
      height: 'max-content',
      margin: '80px 16px 16px',
      boxShadow: '0px 10px 16px #d3cff650',
      border: '1px solid #1f1f3320',
      display: 'flex',
      flexDirection: 'row',
      overflow: 'hidden',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        margin: '80px 16px 16px',
      },
      [theme.breakpoints.down('xs')]: {
        margin: '24px 0 0',
        borderRadius: '0',
        border: 'none',
        boxShadow: 'none',
      },
    },
    formImage: {
      background: `url(${formImage}) no-repeat center`,
      backgroundSize: 'cover',
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        height: '250px',
        background: `url(${formImage}) no-repeat`,
        backgroundSize: 'cover',
      },
      [theme.breakpoints.down('xs')]: {
        display: 'none',
      },
    },
    formContents: {
      width: '100%',
      boxSizing: 'border-box',
      padding: '60px 16px',
      display: 'flex',
      alignItems: 'center',
      [theme.breakpoints.down('sm')]: {
        padding: '60px 16px',
      },
      [theme.breakpoints.down('xs')]: {
        padding: '60px 0',
      },
    },
    formTitle: {
      color: '#4e4e7e',
      fontSize: '30px',
      fontWeight: '700',
      lineHeight: '1.2',
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: '24px',
      },
    },
    avatarWrapper: {
      [theme.breakpoints.down('sm')]: {
        alignItems: 'center',
      },
    },
    formControlInput: {
      borderRadius: '6px',
      backgroundColor: '#f1edff30',
    },

    buttonContainer: {
      width: '100%',
      // marginTop: '32px',
      padding: '0 24px',
    },
    submitButton: {
      background: '#ff0000',
      width: '100%',
      maxWidth: '300px',
      borderRadius: '99px',
      [theme.breakpoints.down('xs')]: {
        maxWidth: '100%',
      },
    },
  };

  const [error, setError] = useState({});
  const [tabValue, setTabValue] = useState(0);

  const [geonameId, setGeonameId] = useState(null);
  const [country, setCountry] = useState(undefined);
  const [avatarId, setAvatarId] = useState(null);
  const [gender, setGender] = useState(undefined);
  const [bio, setBio] = useState('');
  const [lang, setLang] = useState(undefined);
  const [dob, setDob] = useState(undefined);
  const [avatar, setAvatar] = useState(null);
  const [showUploadDialog, setShowUploadDialog] = useState(false);
  const [loadingCities, setLoadingCities] = useState(false);
  const [cityList, setCityList] = useState([]);
  const [cityName, setCityName] = useState('');

  const [geonameIdWard, setGeonameIdWard] = useState(null);
  const [countryWard, setCountryWard] = useState(null);
  const [avatarIdWard, setAvatarIdWard] = useState(null);
  const [genderWard, setGenderWard] = useState(undefined);
  const [bioWard, setBioWard] = useState('');
  const [langWard, setLangWard] = useState(undefined);
  const [dobWard, setDobWard] = useState(undefined);
  const [avatarWard, setAvatarWard] = useState(null);
  const [showUploadDialogWard, setShowUploadDialogWard] = useState(false);
  const [loadingWardCities, setWardLoadingCities] = useState(false);
  const [cityWardList, setWardCityList] = useState([]);
  const [cityWardName, setWardCityName] = useState('');

  //https://dmitripavlutin.com/react-useeffect-explanation/
  useEffect(() => {
    if (!props.countries) {
      props.fetchCountries();
    }
    if (!props.langs) {
      props.fetchLangs();
    }
    if (!props.sports) {
      props.fetchSports();
    }
  }, []);

  const onSubmit = (event) => {
    event.preventDefault();
    if (props.choicesData === '3-31-311') {
      //current user is guardian
      props
        .userOnBoardBasic(country, geonameId, avatarId, gender, bio, lang, dob)
        .then(() => {
          // push for the ward, send the first email from the wardEmail list
          props
            .nonDefaultUserOnBoardBasic(
              countryWard,
              geonameIdWard,
              avatarIdWard,
              genderWard,
              bioWard,
              langWard,
              dobWard,
              true,
              props.wardEmail[0],
            )
            .then(() => {
              props.history.push(ROUTES.SIGN_UP_INVITES);
            });
        })
        .catch((error) => {
          setError(error);
        });
    } else if (props.choicesData === '3-32-321') {
      //current user is ward
      props
        .userOnBoardBasic(
          countryWard,
          geonameIdWard,
          avatarIdWard,
          genderWard,
          bioWard,
          langWard,
          dobWard,
        )
        .then(() => {
          props
            .nonDefaultUserOnBoardBasic(
              country,
              geonameId,
              avatarId,
              gender,
              bio,
              lang,
              dob,
            )
            .then(() => {
              props.history.push(ROUTES.SIGN_UP_INVITES);
            });
        })
        .catch((error) => {
          setError(error);
        });
    }
  };

  const onWardCityHandleChange = debounce(async (newCityQS) => {
    setWardLoadingCities(true);
    const newList = await autoSuggestCities(newCityQS);
    setWardCityList(newList || []);
    setWardLoadingCities(false);
  }, 1000);

  const onWardCityChange = (e, v) => {
    if (v) {
      setWardCityName(v.name);
      setGeonameIdWard(v.value);
      setCountryWard(v.cc);
    }
  };

  const onCityHandleChange = debounce(async (newCityQS) => {
    setLoadingCities(true);
    const newList = await autoSuggestCities(newCityQS);
    setCityList(newList || []);
    setLoadingCities(false);
  }, 1000);

  const onCityChange = (e, v) => {
    if (v) {
      setCityName(v.name);
      setGeonameId(v.value);
      setCountry(v.cc);
    }
  };

  const onChangeAvatar = async (newImage, newFile) => {
    setAvatar(newImage);
    setShowUploadDialog(false);
    const res = await uploadFile(newFile);
    if (res) {
      console.log('newAvatarId', res.data.media_id);
      setAvatarId(res.data.media_id);
    }
  };

  const onChangeAvatarWard = async (newImage, newFile) => {
    setAvatarWard(newImage);
    setShowUploadDialogWard(false);
    const res = await uploadFile(newFile);
    if (res) {
      console.log('newAvatarId', res.data.media_id);
      setAvatarIdWard(res.data.media_id);
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const isInvalid =
    geonameId === '' ||
    country === '' ||
    avatarId === '' ||
    gender === '' ||
    bio === '' ||
    lang === '' ||
    geonameIdWard === '' ||
    countryWard === '' ||
    avatarIdWard === '' ||
    genderWard === '' ||
    bioWard === '' ||
    dobWard === '' ||
    langWard === '';

  return (
    <Box display="flex" justifyContent="center" sx={classes.root}>
      <Paper elevation={0} sx={classes.formWrapper}>
        <Box sx={classes.formImage}></Box>
        <Box sx={classes.formContents}>
          <Grid spacing={2} direction="row" container>
            <Grid item xs={12}>
              <Box display="flex" justifyContent="center">
                <Paper>
                  <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    aria-label={_lt('Basic Information')}
                  >
                    <Tab label={_lt('Guardian info')} {...a11yProps(0)} />
                    <Tab label={_lt('Ward info')} {...a11yProps(1)} />
                  </Tabs>
                </Paper>
              </Box>
              <form onSubmit={onSubmit}>
                <Box display="flex" justifyContent="center">
                  <TabPanel value={tabValue} index={0}>
                    <Grid
                      spacing={2}
                      direction="row"
                      //alignItems="center"
                      container
                      sx={classes.tabBox}
                    >
                      <Grid item xs={12}>
                        <Typography
                          variant="h6"
                          sx={classes.formTitle}
                          gutterBottom
                        >
                          {_lt('Need the following details about you')}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <FormControl
                          sx={classes.avatarWrapper}
                          variant="outlined"
                          size="small"
                          error={
                            props.onBoardErrors &&
                            !!props.onBoardErrors.avatar_id
                          }
                        >
                          <Avatar
                            sx={{ border: '1px solid gainsboro' }}
                            alt="Avatar"
                            src={avatar}
                            onClick={() => setShowUploadDialog(true)}
                          />
                          {props.onBoardErrors &&
                            !!props.onBoardErrors.avatar_id && (
                              <FormHelperText id="avatarId-text">
                                {_lt(props.onBoardErrors.avatar_id)}
                              </FormHelperText>
                            )}
                          <ImageUpload
                            roundShape={true}
                            show={showUploadDialog}
                            handleClose={() => setShowUploadDialog(false)}
                            handleUpload={(newImage, newFile) =>
                              onChangeAvatar(newImage, newFile)
                            }
                            header={_lt('Profile photo')}
                          />
                          <Typography
                            variant="caption"
                            display="block"
                            gutterBottom
                          >
                            {_lt('Please add/edit your avatar image')}
                          </Typography>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12}>
                        <FormControl variant="outlined" size="small">
                          <Autocomplete
                            size="small"
                            id="city-search"
                            autoSelect
                            selectOnFocus
                            getOptionSelected={(option, value) =>
                              option.name === value.name
                            }
                            getOptionLabel={(option) => {
                              // Add "xxx" option created dynamically
                              if (option.value) {
                                return option.name;
                              }
                              // Regular option
                              return '';
                            }}
                            options={cityList}
                            loading={loadingCities}
                            onChange={(e, v) => onCityChange(e, v)}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={_lt('Type your city name')}
                                variant="outlined"
                                onChange={(e) => {
                                  // dont fire API if the user delete or not entered anything
                                  if (
                                    e.target.value !== '' ||
                                    e.target.value !== null
                                  ) {
                                    onCityHandleChange(e.target.value);
                                  }
                                }}
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <React.Fragment>
                                      {loadingCities ? (
                                        <CircularProgress
                                          color="inherit"
                                          size={20}
                                        />
                                      ) : null}
                                      {params.InputProps.endAdornment}
                                    </React.Fragment>
                                  ),
                                }}
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12} lg={6}>
                        <FormControl
                          variant="outlined"
                          size="small"
                          error={
                            props.onBoardErrors && !!props.onBoardErrors.gender
                          }
                        >
                          <InputLabel id="gender-select-label">
                            {_lt('Gender')}
                          </InputLabel>
                          <Select
                            sx={classes.formControlInput}
                            name="gender"
                            label="Gender"
                            value={gender}
                            onChange={(e) => setGender(e.target.value)}
                            placeholder={_lt('Gender')}
                          >
                            <MenuItem key="neutral" value={0}>
                              {_lt('Neutral')}
                            </MenuItem>
                            <MenuItem key="female" value={1}>
                              {_lt('Female')}
                            </MenuItem>
                            <MenuItem key="male" value={2}>
                              {_lt('Male')}
                            </MenuItem>
                          </Select>
                          {props.onBoardErrors &&
                            !!props.onBoardErrors.gender && (
                              <FormHelperText id="gender-text">
                                {_lt(props.onBoardErrors.gender)}
                              </FormHelperText>
                            )}
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12} lg={6}>
                        <FormControl
                          variant="outlined"
                          size="small"
                          error={
                            props.onBoardErrors && !!props.onBoardErrors.lang
                          }
                        >
                          <InputLabel id="lang-select-label">
                            {_lt('Preferred Site Language')}
                          </InputLabel>
                          <Select
                            sx={classes.formControlInput}
                            name="lang"
                            label={_lt('Preferred Site Language')}
                            value={lang}
                            onChange={(e) => setLang(e.target.value)}
                            placeholder={_lt('Preferred Site Language')}
                          >
                            {props.langs &&
                              props.langs.map((x, i) => (
                                <MenuItem key={`lang-${i}`} value={x.lang_code}>
                                  {x.lang_name}
                                </MenuItem>
                              ))}
                          </Select>
                          {props.onBoardErrors &&
                            !!props.onBoardErrors.lang && (
                              <FormHelperText id="lang-text">
                                {_lt(props.onBoardErrors.lang)}
                              </FormHelperText>
                            )}
                        </FormControl>
                      </Grid>
                      <Grid item xs={12}>
                        <FormControl
                          variant="outlined"
                          error={
                            props.onBoardErrors && !!props.onBoardErrors.bio
                          }
                        >
                          <TextField
                            sx={classes.formControlInput}
                            id="outlined-multiline-static"
                            label={_lt('Something about yourself')}
                            multiline
                            rows={4}
                            variant="outlined"
                            value={bio}
                            onChange={(e) => setBio(e.target.value)}
                            placeholder={_lt('Bio')}
                          />
                          {props.onBoardErrors && !!props.onBoardErrors.bio && (
                            <FormHelperText id="bio-text">
                              {_lt(props.onBoardErrors.bio)}
                            </FormHelperText>
                          )}
                        </FormControl>
                      </Grid>
                    </Grid>
                  </TabPanel>
                  {/** SECOND TAB */}
                  <TabPanel value={tabValue} index={1}>
                    <Grid
                      spacing={2}
                      direction="row"
                      //alignItems="center"
                      container
                    >
                      <Grid item xs={12}>
                        <Typography
                          variant="h6"
                          sx={classes.formTitle}
                          gutterBottom
                        >
                          {_lt('Need the following details about your ward')}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <FormControl
                          sx={classes.avatarWrapper}
                          variant="outlined"
                          size="small"
                          error={
                            props.onBoardErrors &&
                            !!props.onBoardErrors.avatar_id
                          }
                        >
                          <Avatar
                            sx={{ border: '1px solid gainsboro' }}
                            alt="Avatar"
                            src={avatarWard}
                            onClick={() => setShowUploadDialogWard(true)}
                          />
                          {props.onBoardErrors &&
                            !!props.onBoardErrors.avatar_id && (
                              <FormHelperText id="avatarId1-text">
                                {_lt(props.onBoardErrors.avatar_id)}
                              </FormHelperText>
                            )}
                          <ImageUpload
                            roundShape={true}
                            show={showUploadDialogWard}
                            handleClose={() => setShowUploadDialogWard(false)}
                            handleUpload={(newImage, newFile) =>
                              onChangeAvatarWard(newImage, newFile)
                            }
                            header={_lt('Profile photo')}
                          />
                          <Typography
                            variant="caption"
                            display="block"
                            gutterBottom
                          >
                            {_lt("Please add/edit your ward's avatar image")}
                          </Typography>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12}>
                        <FormControl variant="outlined" size="small">
                          <Autocomplete
                            size="small"
                            id="city-ward-search"
                            autoSelect
                            selectOnFocus
                            getOptionSelected={(option, value) =>
                              option.name === value.name
                            }
                            getOptionLabel={(option) => {
                              // Add "xxx" option created dynamically
                              if (option.value) {
                                return option.name;
                              }
                              // Regular option
                              return '';
                            }}
                            options={cityList}
                            loading={loadingCities}
                            onChange={(e, v) => onWardCityChange(e, v)}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={_lt('City')}
                                variant="outlined"
                                onChange={(e) => {
                                  // dont fire API if the user delete or not entered anything
                                  if (
                                    e.target.value !== '' ||
                                    e.target.value !== null
                                  ) {
                                    onWardCityHandleChange(e.target.value);
                                  }
                                }}
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <React.Fragment>
                                      {loadingCities ? (
                                        <CircularProgress
                                          color="inherit"
                                          size={20}
                                        />
                                      ) : null}
                                      {params.InputProps.endAdornment}
                                    </React.Fragment>
                                  ),
                                }}
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12} lg={6}>
                        <FormControl
                          variant="outlined"
                          size="small"
                          error={
                            props.onBoardErrors && !!props.onBoardErrors.gender
                          }
                        >
                          <InputLabel id="gender-select-label">
                            {_lt('Gender')}
                          </InputLabel>
                          <Select
                            sx={classes.formControlInput}
                            name="gender"
                            label="Gender"
                            value={genderWard}
                            onChange={(e) => setGenderWard(e.target.value)}
                            placeholder={_lt('Gender')}
                          >
                            <MenuItem key="neutral" value={0}>
                              {_lt('Neutral')}
                            </MenuItem>
                            <MenuItem key="female" value={1}>
                              {_lt('Female')}
                            </MenuItem>
                            <MenuItem key="male" value={2}>
                              {_lt('Male')}
                            </MenuItem>
                          </Select>
                          {props.onBoardErrors &&
                            !!props.onBoardErrors.gender && (
                              <FormHelperText id="gender1-text">
                                {_lt(props.onBoardErrors.gender)}
                              </FormHelperText>
                            )}
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12} lg={6}>
                        <FormControl
                          variant="outlined"
                          size="small"
                          error={
                            props.onBoardErrors && !!props.onBoardErrors.lang
                          }
                        >
                          <InputLabel id="lang-select-label">
                            {_lt('Preferred Site Language')}
                          </InputLabel>
                          <Select
                            sx={classes.formControlInput}
                            name="lang"
                            label={_lt('Preferred Site Language')}
                            value={langWard}
                            onChange={(e) => setLangWard(e.target.value)}
                            placeholder={_lt('Preferred Site Language')}
                          >
                            {props.langs &&
                              props.langs.map((x, i) => (
                                <MenuItem key={`lang-${i}`} value={x.lang_code}>
                                  {x.lang_name}
                                </MenuItem>
                              ))}
                          </Select>
                          {props.onBoardErrors &&
                            !!props.onBoardErrors.lang && (
                              <FormHelperText id="lang1-text">
                                {_lt(props.onBoardErrors.lang)}
                              </FormHelperText>
                            )}
                        </FormControl>
                      </Grid>
                      <Grid item xs={12}>
                        <FormControl
                          variant="outlined"
                          error={
                            props.onBoardErrors && !!props.onBoardErrors.bio
                          }
                        >
                          <TextField
                            sx={classes.formControlInput}
                            id="outlined-multiline-static"
                            label={_lt('Something about your ward')}
                            multiline
                            rows={4}
                            variant="outlined"
                            value={bioWard}
                            onChange={(e) => setBioWard(e.target.value)}
                            placeholder={_lt('Bio')}
                          />
                          {props.onBoardErrors && !!props.onBoardErrors.bio && (
                            <FormHelperText id="bio1-text">
                              {_lt(props.onBoardErrors.bio)}
                            </FormHelperText>
                          )}
                        </FormControl>
                      </Grid>
                    </Grid>
                  </TabPanel>
                </Box>
              </form>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="center"
                sx={classes.buttonContainer}
              >
                <ColoredButton
                  sx={classes.submitButton}
                  disabled={isInvalid}
                  type="submit"
                  variant="contained"
                  bgcolor={red}
                  disableElevation
                >
                  {_lt('Save')}
                </ColoredButton>
                <Typography variant="caption" display="block" gutterBottom>
                  {error.message}
                  {props.onBoardErrors}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  onBoardErrors: state.register.onBoardErrors,
  choicesData: state.register.choicesData,
  wardEmail: state.register.wardEmail,
  countries: state.common.countries,
  langs: state.common.langs,
  sports: state.common.sports,
});

const mapDispatchToProps = {
  userOnBoardBasic,
  fetchCountries,
  fetchLangs,
  fetchSports,
};

const GuardianOnBoardBasicForm = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(GuardianOnBoardBasic),
);

export default GuardianOnBoardBasicForm;
